import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'
import topeditEnLocale from '../static/locale/en.json'
import topeditZhLocale from '../static/locale/zh-CN.json'

Vue.use(VueI18n)

const messages = {
  en: {
    ...topeditEnLocale,
    ...enLocale
  },
  zh: {
    ...topeditZhLocale,
    ...zhLocale
  }
}
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

// new Vue({ i18n }).$mount('#app')

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js